<ng-template #content_font_setting_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.seller">
        <div class="side_popup_header">
            <span>{{localService.languageContent.seller.font_settings}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'height' : (localService.sideBarBodyHeight - 25) + 'px'}" *ngIf="data">
        <div class="row styled_row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.seller.line_height" />
                <input autocomplete="off" type="number" class="number" [ngClass]="data.lineHeight ? '' : 'en'"
                    title="{{localService.languageContent.seller.line_height}}"
                    placeholder="{{localService.languageContent.seller.line_height}}"
                    (keypress)="localService.isNumberOnly($event)" style="width:100px;" [(ngModel)]="data.lineHeight"
                    id="{{elementIds.lineHeight}}" />
            </div>
        </div>
        <div class="row styled_row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.seller.item_line_height" />
                <input autocomplete="off" type="number" class="number" [ngClass]="data.itemsLineHeight ? '' : 'en'"
                    title="{{localService.languageContent.seller.item_line_height}}"
                    placeholder="{{localService.languageContent.seller.item_line_height}}"
                    (keypress)="localService.isNumberOnly($event)" style="width:100px;"
                    [(ngModel)]="data.itemsLineHeight" id="{{elementIds.itemsLineHeight}}" />
            </div>
        </div>
        <div *ngFor="let item of data.fontNameOptions;">
            <div class="row styled_row box"
                *ngIf="!searchLanguage || searchLanguage.length == 0 || item.s_value.indexOf(searchLanguage) > -1">
                <div class="col-12">
                    <div>
                        <app-label [Text]="item.value" />
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.isNoFont" />
                            <span class="normal_color">Use system font</span>
                        </label>
                    </div>
                    <div>
                        <ngx-select *ngIf="item.fontOptions.length > 0"
                            placeholder="{{localService.languageContent.seller.font_name}}"
                            title="{{localService.languageContent.seller.font_name}}"
                            [(ngModel)]="item.selectedFontNameCode" [noAutoComplete]="true" [items]="item.fontOptions"
                            [optionValueField]="'key'" [optionTextField]="'value'">
                        </ngx-select>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div>
                                <app-label [Text]="localService.languageContent.seller.font_size" [IsBold]="false"
                                    [IsColonRequired]="false" />
                            </div>
                            <input autocomplete="off" type="number" class="number"
                                [ngClass]="item.selectedFontSize ? '' : 'en'"
                                title="{{localService.languageContent.seller.font_size}}"
                                placeholder="{{localService.languageContent.seller.font_size}}"
                                (keypress)="localService.isNumberOnly($event)" [(ngModel)]="item.selectedFontSize"
                                id="{{elementIds.fontSize + '_' + item.languageCode}}" />
                        </div>
                        <div class="col-6">
                            <div>
                                <app-label [Text]="localService.languageContent.seller.line_height" [IsBold]="false"
                                    [IsColonRequired]="false" />
                            </div>
                            <input autocomplete="off" type="number" class="number"
                                [ngClass]="item.selectedLineHeight  ? '' : 'en'"
                                title="{{localService.languageContent.seller.line_height}}"
                                placeholder="{{localService.languageContent.seller.line_height}}"
                                (keypress)="localService.isNumberOnly($event)" [(ngModel)]="item.selectedLineHeight"
                                id="{{elementIds.lineHeight + '_' + item.languageCode}}" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-7">
                <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="searchLanguage"
                    title="{{localService.languageContent.common.search}}" id="{{elementIds.search}}"
                    placeholder="{{localService.languageContent.common.search}}" />
            </div>
            <div class="col-5" style="text-align: right;">
                <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onAction(1)">
                    {{localService.languageContent.common.save}}
                </button>
            </div>
        </div>
    </div>
</ng-template>